// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"127":"80eba1c4","276":"5d0c65bb","744":"b893e64e","762":"0a7f2b83","787":"513cf44a"}[chunkId] + ".chunk.js";
};